// src/components/ui/forms/FormField/FormField.jsx
import React from 'react';
import { cn } from '../../../../utils/cn';

const FormField = ({
  label,
  children,
  error,
  required = false,
  helpText,
  className = '',
  labelClassName = '',
  spacing = 'default'
}) => {
  // Spacing configurations
  const spacingConfig = {
    tight: "space-y-1",
    default: "space-y-2",
    relaxed: "space-y-3"
  };

  // Label styles matching the login page
  const labelStyles = cn(
    "block text-sm font-medium text-slate-300",
    labelClassName
  );

  // Error text styles
  const errorStyles = cn(
    "text-sm text-red-400 flex items-center gap-2 mt-1"
  );

  // Help text styles
  const helpTextStyles = cn(
    "text-xs text-slate-500 mt-1"
  );

  return (
    <div className={cn(spacingConfig[spacing], className)}>
      {/* Label */}
      {label && (
        <label className={labelStyles}>
          {label}
          {required && <span className="text-red-400 ml-1">*</span>}
        </label>
      )}

      {/* Input/Content */}
      <div>
        {React.cloneElement(children, { 
          error: !!error,
          required,
          'aria-describedby': error ? `${children.props.id || 'field'}-error` : undefined
        })}
      </div>

      {/* Help Text */}
      {helpText && !error && (
        <p className={helpTextStyles}>
          {helpText}
        </p>
      )}

      {/* Error Message */}
      {error && (
        <p 
          className={errorStyles}
          id={`${children.props.id || 'field'}-error`}
        >
          <svg 
            className="w-4 h-4 flex-shrink-0" 
            fill="currentColor" 
            viewBox="0 0 20 20"
          >
            <path 
              fillRule="evenodd" 
              d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z" 
              clipRule="evenodd" 
            />
          </svg>
          {error}
        </p>
      )}
    </div>
  );
};

export default FormField;